<template>
	<div class="nn-profile-form-shell">
		<form
			id="profile-form"
			ref="profileForm"
			class="nn-profile-form"
			enctype="multipart/form-data"
			accept-charset="UTF-8"
			:aria-busy="loading"
			@submit.prevent="submitForm"
		>
			<input type="hidden" :name="csrfName" :value="csrfToken">
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="currentUser.id">

			<div class="nn-profile-form__grid">
				<div class="nn-profile-form__field nn-profile-form__field--full">
					<label class="uk-form-label" for="profile-email">E-mailadres</label>
					<input
						id="profile-email"
						class="uk-input"
						type="email"
						name="email"
						:value="currentUser.email"
						autocomplete="email"
						disabled
					>
					<span class="nn-profile-form__hint">Je e-mailadres kan hier niet worden gewijzigd.</span>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-first-name">Voornaam</label>
					<input
						id="profile-first-name"
						class="uk-input"
						type="text"
						name="firstName"
						:value="currentUser.firstName"
						placeholder="Voornaam"
						autocomplete="given-name"
					>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-last-name">Achternaam</label>
					<input
						id="profile-last-name"
						class="uk-input"
						type="text"
						name="lastName"
						:value="currentUser.lastName"
						placeholder="Achternaam"
						autocomplete="family-name"
					>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-nickname">Naam bij reacties</label>
					<input
						id="profile-nickname"
						class="uk-input"
						type="text"
						name="fields[nickName]"
						:value="currentUser.nickName"
						placeholder="Naam bij reacties"
						autocomplete="nickname"
					>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-gender">Geslacht</label>
					<select id="profile-gender" class="uk-select" name="fields[gender]" v-model="selectedGender">
						<option value="">Geen keuze</option>
						<option
							v-for="option in genders"
							:key="option.value"
							:value="option.value"
						>{{ option.label }}</option>
					</select>
				</div>

				<div class="nn-profile-form__field">
					<label class="uk-form-label" for="profile-birthdate">Geboortedatum</label>
					<input
						id="profile-birthdate"
						class="uk-input"
						name="fields[birthdate]"
						type="date"
						:value="currentUser.birthdate || ''"
						autocomplete="bday"
					>
				</div>
			</div>

			<div class="nn-profile-form__actions">
				<button class="uk-button uk-button-primary" type="submit" :disabled="loading">
					Wijzigingen opslaan
				</button>
			</div>

			<div
				v-show="overlay"
				class="nn-profile-feedback"
				:class="{ 'is-error': error, 'is-success': success }"
				:role="error ? 'alert' : 'status'"
				:aria-live="error ? 'assertive' : 'polite'"
			>
				<loading-indicator v-if="loading"></loading-indicator>
				<span v-else-if="error" class="material-symbols-outlined" aria-hidden="true">error</span>
				<span v-else-if="success" class="material-symbols-outlined" aria-hidden="true">done</span>
				<p v-if="message" v-text="message"></p>
			</div>
		</form>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'ProfileForm',
	components: { LoadingIndicator },
	props: {
		genders: {
			type: Array,
			required: true,
		},
		currentUser: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			overlay: false,
			error: false,
			success: false,
			loading: false,
			message: '',
			selectedGender: this.currentUser.gender || '',
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName
		},
		csrfToken() {
			return window.csrfTokenValue
		},
	},
	methods: {
		responseErrorMessage(data = {}) {
			const messages = [];

			if (data.error) {
				messages.push(data.error);
			}

			if (data.errors) {
				Object.values(data.errors).forEach((fieldErrors) => {
					if (Array.isArray(fieldErrors)) {
						messages.push(...fieldErrors);
					}
				});
			}

			return messages.join('\n');
		},
		showError(message) {
			this.loading = false;
			this.error = true;
			this.success = false;
			this.message = message || 'Onbekende fout, probeer het opnieuw.';
			window.setTimeout(this.resetMessage, 5000);
		},
		submitForm(event) {
			const formData = new FormData(event.target);

			this.overlay = true;
			this.loading = true;
			this.error = false;
			this.success = false;
			this.message = '';

			axios({
				method: 'post',
				url: '/actions/users/save-user',
				responseType: 'json',
				data: formData,
				headers: {
					'Accept': 'application/json'
				}
			})
			.then((response) => {
				const errorMessage = this.responseErrorMessage(response.data);

				if (errorMessage) {
					this.showError(errorMessage);
					return;
				}

				this.loading = false;
				this.success = true;
				this.message = 'Gegevens bijgewerkt.';
				window.setTimeout(this.resetMessage, 2200);
			})
			.catch((requestError) => {
				const responseData = requestError.response?.data || {};
				this.showError(this.responseErrorMessage(responseData) || responseData.message);
			});
		},
		resetMessage() {
			this.message = '';
			this.error = false;
			this.success = false;
			this.overlay = false;
			this.loading = false;
		}
	},
};
</script>
